import useMutationSellerCreateUpdate from './seller-use-mutation-create-update';
import useMutationSellerRemove from './seller-use-mutation-remove';


export const sellerUseMutation = {
  createUpdate: useMutationSellerCreateUpdate,
  remove: useMutationSellerRemove,
}